const voipServicesExample = [
  [
    "507554",
    "0**********",
    "12",
    "Example Name",
    "Residential",
    "12",
    "aperture",
    "street",
    "Coburg North",
    "VIC",
    "3058",
    "dd/mm/yyyy",
    "12",
    "2sgVoIP",
    "test department",
    "dd/mm/yyyy"
  ]
];

const transactionsExample = [
  ["507554", "0**********", "something", "12", "dd/mm/yyyy"],
];

const newMobilesExample = [
  [
    "507554",
    "0**********",
    "12",
    "Example Name",
    "Residential",
    "12",
    "aperture",
    "street",
    "Coburg North",
    "VIC",
    "3058",
    "dd/mm/yyyy",
    "12",
    "4G",
  ],
];

const disconnectExample = [["507554", "0**********", "dd/mm/yyyy"]];

const nbnExample = [
  [
    "503315",
    "46",
    "SANFORD ROAD",
    "",
    "CENTENNIAL PARK",
    "WA",
    "6330",
    "2ZG-100002803782",
    "FTTN",
    "5468644@trikon.net.au",
    "CnUZ9paw",
    "1437",
    "0",
    "23/03/2021",
    "LOC000014544386",
    "110.239.136.146",
    "13",
    "CPI300004812403",
    "1",
    "optus (nbn)",
    "test department",
    "23/03/2021"
  ]
];

const mnfAgentExampleData = [
  [
    "Acrotec Pty Ltd",
    "123156468",
    "Suite 22 7 Narabang RdBelrose NSW 2085",
    "Test Person",
    "test@test.com.au",
    "Acrotec Pty Ltd",
    "122456",
    "123456789",
    "1234",
  ],
];

const customerExample = [
  [
    "CHELSEA HEARING PTY LTD - Chelsea",
    "714722",
    "714722",
    "Business",
    "STE 3 8 The Strand ST Chelsea VIC 3196",
    "Mrs",
    "Cathryn",
    "Williams",
    "07********",
    "04********",
    "contact@email.com.au",
    "custom@billing.com",
    "1****",
    "PBX Domain",
    "6*****",
    "9",
    "1",
    "Y",
    "supersecretpassword"
  ],
];
const customer2Example = [
  [
    "CHELSEA HEARING PTY LTD - Chelsea",
    "714722",
    "714722",
    "Business",
    "3196",
    "stand st",
    "test",
    "test",
    "QLD",
    "6000",
    "Mrs",
    "Cathryn",
    "Williams",
    "07********",
    "04********",
    "contact@email.com.au",
    "custom@billing.com",
    "1****",
    "PBX Domain",
    "6*****",
    "9",
    "1"
  ],
];

const inboundExample = [
  [
    "514261",
    "2ZG-100002803782test",
    "29",
    "Test Customer",
    "15/08/2022",
    "12",
    "Symbio Inbound",
    "Test Department",
    "18/08/2022"
    // "Suite 22 7 Narabang RdBelrose NSW 2085",
  ]
];

const recurringCharges = [
  "500000", //ubCustno
  "0240581572", //serviceID
  "100",//amount,
  "test description",
  "15/08/2022",//start date
  "17/08/2022",//end date
]

export {
  voipServicesExample,
  transactionsExample,
  newMobilesExample,
  disconnectExample,
  nbnExample,
  mnfAgentExampleData,
  customerExample,
  inboundExample,
  customer2Example,
  recurringCharges
};
